/**
 * Barra de fracciones item
 * @param {*} editor
 */
function fractionsBar(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `\\frac{${text}}{${text}}`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'fractionBar',
    action: fractionsBar,
    className: 'fractionicon',
    title: 'Barra de fracciones',
  };

  return option;
}
